/** Label for the comparison window (same length, immediately before startDate). */
export function formatPreviousPeriodLabel(startDate?: string, endDate?: string): string {
  if (!startDate || !endDate) {
    return 'período anterior';
  }

  const start = new Date(`${startDate}T12:00:00`);
  const end = new Date(`${endDate}T12:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return 'período anterior';
  }

  const diffDays = Math.ceil((end.getTime() - start.getTime()) / 86_400_000);
  if (diffDays <= 0) {
    return 'período anterior';
  }

  if (diffDays === 1) {
    return 'día anterior';
  }

  return `${diffDays} días anteriores`;
}
